import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RegisterComponent } from '../../Home/register/register';

@Component({
  selector: 'app-inventory-hero',
  standalone: true,
  imports: [CommonModule, RegisterComponent],
  templateUrl: './inventory-hero.html',
  styleUrls: ['./inventory-hero.css'],
})
export class InventoryHeroComponent {
  showRegister = false;
  inventoryApp = [{ name: 'Inventory', image: 'images/webps/inventory.svg' }];
}
